import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Spell } from "../../../shared/models/spell";
import { SpellsService } from "../../../shared/services/spells/spells.service";
import { Observable } from "rxjs/Observable";
import { Store } from "../../../store";
import { Subscription } from "rxjs/Subscription";

@Component({
  selector: "app-spell-dashboard",
  templateUrl: "./spell-dashboard.component.html",
  styleUrls: ["./spell-dashboard.component.scss"]
})
export class SpellDashboardComponent implements OnInit, OnDestroy {
  spells$: Observable<Spell[]>;
  subscription: Subscription;

  constructor(private spellsService: SpellsService, private store: Store) {}

  ngOnInit() {
    this.spells$ = this.store.select<Spell[]>("spells");
    this.subscription = this.spellsService.spells$.subscribe();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/spell-dashboard/containers/spell-dashboard/spell-dashboard.component.ts